<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddUser()">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                Add User
            </h4>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields v-if="!message" :fields="fields" v-model="user" />
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
                <div v-if="message">
                    {{ message }}
                </div>
                <div v-if="modalData?.checkList" class="mt-2">
                    <InputField type="checkbox" label="Daily Count Email" v-model="alert" :editable="true" :visible="true" />
                    <InputField type="checkbox" label="Notification Email" v-model="notification" :editable="true" :visible="true" />
                </div>
        </div>
        <div class="card-footer" v-if="!message">
            <div class="text-end">
                <submit-button :fields="fields" v-model="user" :loading="loading" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import InputField from '../InputField.vue'
import {mapActions} from 'vuex'
import Fields from "../../utils/field-constants/userCreateFields.js"
export default {
    components: { formFields, submitButton, InputField },
    data(){
        return {
            error: "",
            message: "",
            user: {},            
            fields: JSON.parse(JSON.stringify(Fields)),
            alert: false,
            notification: false,
            loading: false
        }
    },
    props: {
       modalData: {
            type: Object,
            default: () => ({})
        }
    },
    name: "AddUser",    
    methods: {
        ...mapActions('admin', {
            createUser: 'upsertUser',
            readClientV2: 'readClientV2',
            updateClientV2: 'updateClientV2'
        }),
        ...mapActions('aut', {
            fetchClient: 'fetchClient',
            updateAutClientData: 'updateAutClientData'
        }),
        async onAddUser() {
            this.loading = true;
            try {
                await this.createUser(this.user)
                
                // Call the callback after successful user creation
                if (this.modalData?.checkList) {
                    await this.handleAlertNotification();
                    if (this.modalData?.onAddUser && typeof this.modalData.onAddUser === 'function') {
                        this.modalData.onAddUser(this.user, this.alert, this.notification);
                    }
                }

                this.$store.dispatch('addToast', {
                    message: `User '${this.user.email}' added successfully.`,
                    type: 'success'
                });
                this.$store.dispatch('hideModal');
            } catch (error) {                
                // if (error.response.data.error) 
                //     this.error = error.response.data.error
                // else 
                //     this.error = error.message

                this.error = `Failed to create user '${this.user.email}'. Please contact support.`;

                // To Be Removed
                if (this.modalData?.checkList) {
                    await this.handleAlertNotification();
                    if (this.modalData?.onAddUser && typeof this.modalData.onAddUser === 'function') {
                        this.modalData.onAddUser(this.user, this.alert, this.notification);
                    }
                }
                
                return
            }

            this.loading = false;

            //this.$store.dispatch('hideModal')
            this.$store.dispatch('admin/fetchUsers')
        },
        async handleAlertNotification() {
            await Promise.all([
                (async () => {
                    if (this.alert) {
                        let clientData;
                        await this.fetchClient().then(response => {
                            clientData = response.data;
                        }).catch(error => {
                            const err = error.response?.data.error ? error.response.data.error : error.message;
                            console.error("Error fetching client data: ", err);
                        });

                        if (clientData && clientData.dailyCountEmails) {
                            // Add user email if not already present
                            if (!clientData.dailyCountEmails.includes(this.user.email)) {
                                clientData.dailyCountEmails.push(this.user.email);
                            } else return;

                            // Update the client data with modified dailyCountEmails(alerts)
                            await this.updateAutClientData(clientData).catch(error => {
                                const err = error.response?.data.error ? error.response.data.error : error.message;
                                console.error("Error updating alert: ", err);
                            });
                        }
                    }
                })(),
                (async () => {
                    if (this.notification) {
                        let clientV2Data;
                        await this.readClientV2(this.$store.state.currentClient.cid).then(response => {
                            clientV2Data = response.data;
                        }).catch(error => {
                            const err = error.response?.data.error ? error.response.data.error : error.message;
                            console.error("Error fetching client data: ", err);
                        });

                        if (clientV2Data && clientV2Data.notification_emails) {
                            // Add user email if not already present
                            if (!clientV2Data.notification_emails.includes(this.user.email)) {
                                clientV2Data.notification_emails.push(this.user.email);
                            } else return;

                            // Update the client v2 data with modified notification_emails(notifications)
                            await this.updateClientV2(clientV2Data).catch(error => {
                                const err = error.response?.data.error ? error.response.data.error : error.message;
                                console.error("Error updating notification: ", err);
                            });
                        }
                    }
                })()
            ]);
        }
    },
    beforeMount() {  
        let self = this;     
        if(!self.$store.getters.userRoles.isAqferAdmin && !self.$store.getters.userRoles.isAqferManager && self.$store.getters.userRoles.isClientAdmin) {
            this.user.roles =  ["client_user"];
            this.user.cids = self.$store.state.currentUser.cids;
        }
        else if (!self.$store.getters.userRoles.isAqferAdmin && self.$store.getters.userRoles.isAqferManager) {
            this.fields.map((field)=>{
                if (field.name == "roles" ) {
                    field.options = ["aqfer_user","client_admin","client_user"]
                }
            })
        }
        if(this.modalData && this.modalData.checkList) {
            // restrict cid to current value
            this.fields[2].editable = false;
            this.user.cids = [self.$store.state.currentClient.cid];

            // restrict roles to 'client_admin' and 'client_user'
            this.fields[3].options = ["client_admin", "client_user"];
        }
            
    },
};
</script>

<style>
</style>